// extracted by mini-css-extract-plugin
module.exports = {"root":"AfterFrontImage_root__ciXk2","title":"AfterFrontImage_title__3r-hk"};